import React, { useState, useEffect } from "react";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
import { IconPencil, IconPrinter } from "@tabler/icons-react";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./create-page";
import ChangeOrderDate from "./canvas-order/change-order-date";
// import PembayaranOrder from "./canvas-order/pembayaran-order";
import ChangeOrderStatus from "./canvas-order/change-order-status";
// import ChangeSession from "./canvas-order/change-session";
import { LabelProvider, useLabel } from "contexts/v1/masterData/LabelContext";
import { TripProvider, useTrip } from "contexts/v1/masterData/TripContext";
import {  useApp } from "contexts/BookingContext";
import { ProductProvider } from "contexts/v1/masterData/ProductContext";
import { AgentProvider, useAgent } from "contexts/v1/masterData/AgentContext";
import { useCustomer } from "contexts/v1/masterData/CustomerContext";
import PrintBookingDetails from "./canvas-order/PrintBookingDetails";
// import { FormGroup } from "react-bootstrap";
import PrintTicket from "./canvas-order/print-ticket";
import { useGuide } from "contexts/v1/masterData/GuideContext";
import UpdateGuide from "./canvas-order/update-guide";

const CardClickPage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/booking"; // API URL sesuai dengan endpoint booking Anda
  const { labels } = useLabel();
  const { trips } = useTrip();
  const { guides } = useGuide();

  // console.log("label", labels);
  // console.log("trips", trips);
  console.log("CardClickPage initialData", initialData);
  const { refetch, sessions } = useApp();
  const { customers } = useCustomer();
  const { agents } = useAgent();

  // console.log("CardClickPage refetch", refetch);
  const [formData, setFormData] = useState({
    // productSelect: "",
    selectedProducts: [],
    price: "",
    quantity: 1,
  });

  const getLabelById = (labelId) => {
    return labels.data.find((l) => l.id === labelId) || null;
  };

  const label = getLabelById(initialData.label_id);

  const getTripById = (tripId) => {
    return trips.data.find((t) => t.id === tripId) || null;
  };

  const trip = getTripById(initialData.trip_id);

  // Helper function to get agent data by id
  const getAgentById = (agentId) => {
    return agents.data.find((a) => a.id === agentId) || null; // Kembalikan seluruh data agent
  };

  // Dapatkan data agent berdasarkan booking.agent_id
  const agent = getAgentById(initialData.agent_id);

  const getGuideById = (guideId) => {
    return guides.data.find((g) => g.id === guideId) || null;
  };

  const guide = getGuideById(initialData.guide_id);

  const isUpdateMode = !!initialData;
  const { handleSuccess, handleError, showCanvasHandler, handleSuccessToast } =
    useCanvasHandler();

  const { createData: createBooking } = useCreateData(
    API_URL,
    "bookings"
  );
  const { updateData: updateBooking } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "bookings"
  );

  const { handleSubmit } = useSubmitHandler(
    isUpdateMode ? updateBooking : createBooking,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
      });
    }
  }, [initialData]);

  const actions = [
    { icon: <IconPencil size={24} />, label: "Ubah Booking" },
    // { icon: <IconListNumbers size={24} />, label: "Ganti Sesi" },
    // { icon: <IconCash size={24} />, label: "Pembayaran Booking" },
    // { icon: <IconTag size={24} />, label: "Ubah Status Booking" },
    {
      icon: <IconPrinter size={24} />,
      label: "Cetak Invoice Pelanggan",
      type: "customer",
    },
    {
      icon: <IconPrinter size={24} />,
      label: "Cetak Ticket & Meal",
      type: "ticket",
    },
  ];

  const handleAction = (e, action) => {
    e.preventDefault();
    // hideCanvas();

    if (action.label === "Detail Booking") {
      showCanvasHandler(
        "Detail Booking",
        // <DetailBooking order={order} />
        <CreatePage onSuccess={handleSuccess} onError={handleError} />
      );
    } else if (action.label === "Ganti Tanggal") {
      showCanvasHandler(
        "Ganti Tanggal",
        <ChangeOrderDate
          onSuccess={() => {
            // handleSuccess(true, "Label created successfully");
            // handleSuccessToast(true, "Label createing");
            refetch();
          }}
        />
        // <ChangeOrderDate
        //   initialData={order}
        //   onSuccess={handleSuccess}
        //   onError={handleError}
        // />
      );
    } else if (action.label === "Ubah Booking") {
      showCanvasHandler(
        "Ubah Booking - " + initialData.code,
        <ProductProvider>
          <AgentProvider>
            <LabelProvider>
              <TripProvider>
                <CreatePage
                  initialData={initialData}
                  refetch={refetch}
                  // onSuccess={handleSuccess}
                  onSuccess={() => {
                    handleSuccess(true, "Reservation Update successfully");
                    refetch();
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000); // Delay 1 second before reloading
                  }}
                  onError={handleError}
                  sessions={sessions}
                  customers={customers}
                />
              </TripProvider>
            </LabelProvider>
          </AgentProvider>
        </ProductProvider>
        // <CreateBooking
        //   initialData={order}
        //   onSuccess={handleSuccess}
        //   onError={handleError}
        // />
      );
    } else if (action.label === "Cetak Invoice Pelanggan") {
      showCanvasHandler(
        "Cetak Invoice Pelanggan",
        <PrintBookingDetails
          booking={initialData}
          agent={agent}
          onSuccess={() => {
            handleSuccessToast(true, "Reservation Print successfully");
            refetch();
          }}
          onError={handleError}
          refetch={refetch}
        />
      );
    } else if (action.label === "Cetak Ticket & Meal") {
      showCanvasHandler(
        "Cetak Ticket & Meal",
        <ProductProvider>
          <AgentProvider>
            <LabelProvider>
              <PrintTicket
                initialData={initialData}
                refetch={refetch}
                // onSuccess={handleSuccess}
                onSuccess={() => {
                  handleSuccess(true, "Reservation Update successfully");
                  refetch();
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000); // Delay 1 second before reloading
                }}
                onError={handleError}
                sessions={sessions}
                customers={customers}
                guide={guide}
              />
            </LabelProvider>
          </AgentProvider>
        </ProductProvider>
      );
    } else {
      return null;
    }
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Booking",
      <ProductProvider>
        <AgentProvider>
          <LabelProvider>
            <CreatePage
              initialData={data}
              // onSuccess={handleSuccess}
              onSuccess={() => {
                handleSuccess(true, "Reservation Update successfully");
                refetch();
              }}
              onError={handleError}
              sessions={sessions}
              customers={customers}
            />
          </LabelProvider>
        </AgentProvider>
      </ProductProvider>
    );
  };

  // Fungsi utilitas
  const formatPrice = (price) => {
    return new Intl.NumberFormat("id-ID").format(price);
  };

  return (
    <>
      {/* card untuk menampilkan sedikit detail dari booking, seperti
      produk/akitfitas yang dipilih, jumlah tamu  */}
      <div className="card card-md mb-3">
        <div className="card-body">
          <div className="row d-flex justify-content-between">
            <div className="col-md-6">
              <h4 className="card-title">Booking Code : {initialData.code}</h4>

              <p className="text-muted">
                Tanggal : {initialData.reservation_date}
              </p>
              {/* <p className="text-muted">Sesi: {initialData.trip_id}</p> */}
              <p className="text-muted">
                Sesi: {trip?.name} | {trip?.start_time} - {trip?.end_time}
              </p>
              {/* <p className="text-muted">
                Produk/Aktivitas: Single (1) & Tandem (1)
              </p> */}
              <p className="text-muted">
                Jumlah Tamu / PAX : {initialData.guest_pax}
              </p>
              {/* guest_transport */}
              <p className="text-muted">
                {/* Transportasi : {initialData.guest_transport} */}
                Transportasi :{" "}
                <span
                  className={`badge text-white bg-${
                    initialData.guest_transport === "PU"
                      ? "green"
                      : initialData.guest_transport === "D"
                      ? "blue"
                      : initialData.guest_transport === "P"
                      ? "yellow"
                      : initialData.guest_transport === "OT"
                      ? "red"
                      : "dark"
                  }`}
                >
                  {initialData.guest_transport === "PU"
                    ? "Pick Up & Drop"
                    : initialData.guest_transport === "D"
                    ? "Drop Only"
                    : initialData.guest_transport === "P"
                    ? "Pick Only"
                    : "Own Transport"}
                </span>
              </p>
              {label && (
                <span
                  className={`mb-3 p-2 badge bg-${label.color} text-uppercase`}
                  title="Status Booking"
                  style={{
                    fontSize: "0.875rem", // Ukuran font yang sesuai untuk badge
                    fontWeight: "600", // Membuat teks lebih menonjol
                    backgroundColor: label.color || "#ccc", // Warna background dari label.color, fallback ke #ccc jika undefined
                    color: "#fff",
                  }}
                >
                  {label.name}
                </span>
              )}
              {/* jika initialData adalah PU maka tampilkan time dan lokasinya */}
              {(initialData.guest_transport === "PU" ||
                initialData.guest_transport === "D" ||
                initialData.guest_transport === "P") && (
                <div className="card bg-primary-lt p-3">
                  <p className="text-muted">
                    Waktu Penjemputan : {initialData.guest_pu_time}
                  </p>
                  <p className="text-muted">
                    Lokasi Penjemputan : {initialData.guest_pu_location}
                  </p>
                  <p className="text-muted">
                    Harga : Rp. {formatPrice(initialData?.guest_pu_price)}
                  </p>
                </div>
              )}
            </div>
            <div className="col-md-6">
              {/* {label && (
                <span
                  className="badge fs-6"
                  style={{
                    backgroundColor: label.color || "#ccc", // Warna background dari label.color, fallback ke #ccc jika undefined
                    color: "#fff", // Pastikan teks terlihat dengan warna putih
                  }}
                  title="Status Booking"
                >
                  <b>{label.name}</b>
                </span>
              )} */}

              {/* buat tombol untuk langsung change status atau option yg langsung bisa mengubah status */}
              <div className="d-flex gap-2">
                <ChangeOrderStatus
                  initialData={initialData}
                  // onSuccess={onSuccess}
                  onSuccess={() => {
                    handleSuccessToast(true, "Reservation Update successfully");
                    refetch();
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000); // Delay 1 second before reloading
                  }}
                  // refetch={refetch}
                />
              </div>
              {/* select option untuk guide trip */}
              <div className="d-flex gap-2">
                <UpdateGuide
                  initialData={initialData}
                  onSuccess={() => {
                    handleSuccessToast(true, "Guide updating");
                    refetch();
                  }}
                  onError={handleError}
                />
              </div>
              <div className="d-flex gap-2">
                {initialData.track === "A" ? (
                  <div className="col-md-12 text-center">
                    <div className="alert alert-info" role="alert">
                      <h4 className="alert-heading">Trip Option A</h4>
                      <p>
                        <span style={{ fontSize: "100px", fontWeight: "bold" }}>
                          A
                        </span>
                      </p>
                    </div>
                  </div>
                ) : initialData.track === "B" ? (
                  <div className="col-md-12 text-center">
                    <div className="alert alert-google" role="alert">
                      <h4 className="alert-heading">Trip Option B</h4>
                      <p>
                        <span style={{ fontSize: "100px", fontWeight: "bold" }}>
                          B
                        </span>
                      </p>
                    </div>
                  </div>
                ) : null}
              </div>
              {/* <p className="text-muted">Total: Rp. 100.000</p> */}
            </div>
          </div>
        </div>
      </div>
      <form
        onSubmit={handleBeforeSubmit}
        className="d-flex flex-column"
        style={{ height: "100%" }}
      >
        <ul>
          {actions.map((action, index) => (
            <li
              key={index}
              className={`mb-5 d-flex align-items-center cursor-pointer ${
                action.isDanger ? "text-danger" : ""
              }`}
              onClick={(e) => handleAction(e, action)}
            >
              {action.icon}
              <span className="ms-2">{action.label}</span>
            </li>
          ))}
        </ul>

        {/* Submit Button */}
        {/* <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update Booking" : "Create Booking"}
        </button>
      </div> */}
      </form>
      <p>print v3</p>
      {/* tombol edit book */}
      {/* <button
        className="btn btn-primary"
        onClick={(e) => handleUpdate(e, initialData)}
      >
        Ubah Booking
      </button> */}
    </>
  );
};

export default CardClickPage;
